import { Injectable } from '@angular/core';
import { DependentFieldFilters, Filter } from '../../interfaces/hubspot-form-data';

@Injectable()
export class HubspotOperators {
    private _operators = [
        { key: 'EQ', func: HubspotOperators.EQ },
        { key: 'NEQ', func: HubspotOperators.NEQ },
        { key: 'CONTAINS', func: HubspotOperators.CONTAINS },
        { key: 'DOESNT_CONTAIN', func: HubspotOperators.DOESNT_CONTAIN },
        { key: 'STR_STARTS_WITH', func: HubspotOperators.STR_STARTS_WITH },
        { key: 'STR_ENDS_WITH', func: HubspotOperators.STR_ENDS_WITH },
        { key: 'LT', func: HubspotOperators.LT },
        { key: 'LTE', func: HubspotOperators.LTE },
        { key: 'GT', func: HubspotOperators.GT },
        { key: 'GTE', func: HubspotOperators.GTE },
        { key: 'BETWEEN', func: HubspotOperators.BETWEEN },
        { key: 'NOT_BETWEEN', func: HubspotOperators.NOT_BETWEEN },
        { key: 'WITHIN_TIME_REVERSE', func: HubspotOperators.WITHIN_TIME_REVERSE },
        { key: 'WITHIN_TIME', func: HubspotOperators.WITHIN_TIME },
        { key: 'IS_NOT_EMPTY', func: HubspotOperators.IS_NOT_EMPTY },
        { key: 'SET_ANY', func: HubspotOperators.SET_ANY },
        { key: 'SET_NOT_ANY', func: HubspotOperators.SET_NOT_ANY },
        { key: 'SET_ALL', func: HubspotOperators.SET_ALL },
        { key: 'SET_NOT_ALL', func: HubspotOperators.SET_NOT_ALL }
    ];

    public static BETWEEN(fieldValue: Filter, parentValue: any) {
        return fieldValue.numberValues[1] > fieldValue.numberValues[0]
            ? parentValue > fieldValue.numberValues[0] && fieldValue.numberValues[1] > parentValue
            : parentValue > fieldValue.numberValues[1] && fieldValue.numberValues[0] > parentValue;
    }

    public static EQ(fieldValue: Filter, parentValue: any) {
        return fieldValue.strValue === parentValue;
    }

    public static NEQ(fieldValue: Filter, parentValue: any) {
        return !HubspotOperators.EQ(fieldValue, parentValue);
    }

    public static CONTAINS(fieldValue: Filter, parentValue: any) {
        return fieldValue.strValue.indexOf(parentValue) > -1;
    }

    public static DOESNT_CONTAIN(fieldValue: Filter, parentValue: any) {
        return fieldValue.strValue.indexOf(parentValue) === -1;
    }

    public static STR_STARTS_WITH(fieldValue: Filter, parentValue: any) {
        return fieldValue.strValue.substring(0, parentValue.length) === parentValue;
    }

    public static STR_ENDS_WITH(fieldValue: Filter, parentValue: any) {
        return fieldValue.strValue.slice(-parentValue.length) === parentValue;
    }

    public static LT(fieldValue: Filter, parentValue: any) {
        return fieldValue.numberValue > parentValue;
    }

    public static LTE(fieldValue: Filter, parentValue: any) {
        return fieldValue.numberValue >= parentValue;
    }

    public static GT(fieldValue: Filter, parentValue: any) {
        return parentValue > fieldValue.numberValue;
    }

    public static GTE(fieldValue: Filter, parentValue: any) {
        return parentValue >= fieldValue.numberValue;
    }

    public static NOT_BETWEEN(fieldValue: Filter, parentValue: any) {
        return !HubspotOperators.BETWEEN(fieldValue, parentValue);
    }

    public static WITHIN_TIME_REVERSE(fieldValue: Filter, parentValue: Date) {
        const d = new Date();
        if ('w' === fieldValue.strValues[1]) {
            d.setDate(d.getDate() - 7 * fieldValue.strValues[0]);
        } else {
            d.setDate(d.getDate() - fieldValue.strValues[0]);
        }
        return d > parentValue;
    }

    public static WITHIN_TIME(fieldValue: any, parentValue: Date) {
        const d = new Date();
        if ('w' === fieldValue.strValues[1]) {
            d.setDate(d.getDate() - 7 * fieldValue.strValues[0]);
        } else {
            d.setDate(d.getDate() - fieldValue.strValues[0]);
        }
        return parentValue > d && parentValue <= new Date();
    }

    public static IS_NOT_EMPTY(fieldValue: any, parentValue: any) {
        return parentValue && 'undefined' !== typeof parentValue.length ? !!parentValue.length : !!parentValue;
    }

    public static SET_ANY(fieldValue: any, parentValue: any) {
        let _isVisible = false;
        const selectedValues = parentValue.split(',');

        for (const selectedValue of selectedValues) {
            _isVisible = fieldValue.strValues.filter((strValue) => strValue === selectedValue).length > 0;
            if (_isVisible) {
                break;
            }
        }
        return _isVisible;
    }

    public static SET_NOT_ANY(fieldValue: any, parentValue: any) {
        return !HubspotOperators.SET_ANY(fieldValue, parentValue);
    }

    public static SET_ALL(fieldValue: any, parentValue: any) {
        for (let r = 0, i = fieldValue.strValues.length; i > r; r++) {
            const n = fieldValue.strValues[r];
            if (-1 === parentValue.toString().indexOf(n)) {
                return !1;
            }
        }
        return !0;
    }

    public static SET_NOT_ALL(fieldValue: any, parentValue: any) {
        return !HubspotOperators.SET_ALL(fieldValue, parentValue);
    }

    public shouldBeVisible(dependentFilter: DependentFieldFilters, parentField = null, currentField = null): boolean {
        let _isVisible = false;
        for (const _filter of dependentFilter.filters) {
            let _parentValue = parentField.value;
            if (currentField && 'booleancheckbox' === currentField.fieldType) {
                if ('EQ' === _filter.operator) {
                    _filter.strValue = _filter.strValues[0];
                    _parentValue = parentField.value.toString();
                }
            }
            _isVisible = this._operators.find((operator) => operator.key === _filter.operator).func(_filter, _parentValue);
            if (_isVisible) {
                break;
            }
        }
        return _isVisible;
    }
}
